import React from 'react';
import './Event_about.css';

const FAQ = (props) => {
    const state = {
        About_item: [
            {
                text: `Learn to build a native-looking desktop app for macOS and Windows using Flutter.`,
            },
            {
                text: `How to communicate Flutter with native code using Flutter Platform Channels`,
            },
            {
                text: `How to use the same build on Staging or Production using Firebase Remote Config - Flutter`,
            },
            {
                text: `Build a game in Flutter in less than an hour`,
            },
            {
                text: `One Plugin, Six Platforms!`,
            },
      ],
    };

    const renderAboutItem = (item, i) => {
        return (
            <div className="about_item">
                <p className="about_text">{item.text}</p>
            </div>
        );
    };

    return (
        <div className="about_wrap">
            <div className="about container">
                <h3 className="about_title">What is this event about</h3>
                <div className="about_blocks">
                    {state.About_item.map((item, i) => renderAboutItem(item, i))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;